import { Alert, Button, Col, Form, Input, Modal, Row, Table, Tooltip } from 'antd';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { apiCall } from '../../API/RestApi';
import { modalError } from '../../Component/Modal/ModalLayout';
import { useSelector } from 'react-redux';
import Search from 'antd/es/input/Search';
import moment from 'moment';

function EmployeeStatus() {
    const token = useSelector((state) => state.user.token);
    const [data, setData] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [isModal, setIsModal] = useState(false);
    const [dataModal, setDataModal] = useState(null);
    const [form] = Form.useForm();
    const [page, setPage] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
        sorter: {
            order: 'desc',
            columnKey: 'employee_status_id',
        }
    });
    const [isAlert, setIsAlert] = useState(false);
    const [textAlert, setTextAlert] = useState('');

    const titlePage = 'Employee Status Data';

    const columns = [
        {
            title: 'No',
            dataIndex: 'no',
            render: (id, record, index) => {
                ++index;
                return (page.pagination.current - 1) * page.pagination.pageSize + index;
            },
        },
        {
            title: 'Name',
            dataIndex: 'name',
            sorter: true,
        },
        {
            title: 'Description',
            dataIndex: 'description',
        },
        {
            title: 'Created At',
            dataIndex: 'created_at',
            sorter: true,
            render: (text, record) => (
                record.created_at ? moment(record.created_at).format('DD-MM-YYYY HH:mm:ss') : '-'
            )
        },
        {
            title: 'Updated At',
            dataIndex: 'updated_at',
            sorter: true,
            render: (text, record) => (
                record.updated_at ? moment(record.updated_at).format('DD-MM-YYYY HH:mm:ss') : '-'
            )
        },
        {
            title: 'Action',
            render: (text, record) => (
                <>
                    <Tooltip title="Edit">
                        <Button type="primary" style={{ marginRight: 10 }} onClick={() => openModal('edit', record)}>
                            <EditOutlined />
                        </Button>
                    </Tooltip>
                    <Tooltip title="Delete">
                        <Button type="primary" danger onClick={() => confirmDelete(record)}>
                            <DeleteOutlined />
                        </Button>
                    </Tooltip>
                </>
            ),
        },
    ];

    useEffect(() => {
        const order = page.sorter?.order === "ascend" ? 'asc' : 'desc';
        const columnKey = page.sorter?.columnKey || 'employee_status_id';

        fetchApi("GET", `/employee-status?search=${search}&page=${page.pagination.current}&limit=${page.pagination.pageSize}&sortBy=${columnKey}&order=${order}`);
    }, [JSON.stringify(page), isAlert]);

    const fetchApi = (method, url) => {
        setLoading(true);

        apiCall({
            method,
            url,
            data: {
                headers: { Authorization: 'Bearer ' + token }
            }
        }).then((res) => {
            if (res.status === "success") {
                setData(res.data.data);
                setPage({
                    ...page,
                    pagination: {
                        ...page.pagination,
                        total: res.data.total_data
                    }
                });
            }
            setLoading(false);
        }).catch(() => setLoading(false));
    };

    const postApi = async (method, url, values) => {
        setLoading(true);
        setIsAlert(false);

        await apiCall({
            method,
            url,
            data: {
                data: values,
                headers: { Authorization: 'Bearer ' + token }
            }
        }).then((res) => {
            if (res.status === "success") {
                setIsAlert(true);
                setTextAlert(res.message);
                closeModal();
            } else {
                modalError(res.message);
            }
            setLoading(false);
        });
    };

    const confirmDelete = (record) => {
        Modal.confirm({
            title: 'NOTICE',
            content: 'Do you want to delete this data?',
            onOk: () => postApi('DELETE', `/employee-status/${record.employee_status_id}`, null),
        });
    };

    const openModal = (type, data) => {
        if (type === 'edit') {
            setDataModal(data);
            form.setFieldsValue({
                name: data.name,
                description: data.description,
            });
        }
        setIsModal(true);
    };

    const onFinish = (values) => {
        if (dataModal) {
            postApi("PUT", `/employee-status/${dataModal.employee_status_id}`, values);
        } else {
            postApi("POST", `/employee-status`, values);
        }
    };

    const closeModal = () => {
        setDataModal(null);
        setIsModal(false);
        form.resetFields();
    };

    const handleTableChange = (pagination, filters, sorter) => {
        setPage({ pagination, filters, sorter });
    };

    const searchData = (value) => {
        setSearch(value);
        setPage({
            pagination: { current: 1, pageSize: 10 }
        });
    };

    return (
        <div>
            <Helmet>
                <title>{titlePage}</title>
            </Helmet>

            {isAlert && <Alert message={textAlert} type="success" banner closable />}

            <h3>Employee Status</h3>

            <Row>
                <Col span={8}>
                    <Search placeholder="Search" enterButton onSearch={searchData} />
                </Col>
                <Col span={16} style={{ textAlign: 'right' }}>
                    <Button type="primary" onClick={() => openModal('add')}>
                        <PlusOutlined /> Add
                    </Button>
                </Col>
            </Row>

            <Table
                columns={columns}
                dataSource={data}
                pagination={page.pagination}
                loading={loading}
                onChange={handleTableChange}
                rowKey="employee_status_id"
            />

            <Modal title="Employee Status" open={isModal} onOk={form.submit} onCancel={closeModal}>
                <Form form={form} layout="vertical" onFinish={onFinish}>
                    <Form.Item
                        name="name"
                        label="Name"
                        rules={[{ required: true, message: 'Name is required!' }]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        name="description"
                        label="Description"
                    >
                        <Input.TextArea />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
}

export default EmployeeStatus;